import React from 'react';

import * as VERSION from '../version';

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

function Home (props) {
  return (
    <Card>
      <CardHeader title="ABDK Toolkit"
                  subheader={
                    <>
                      Collection of useful tools by
                      {' '}
                      <Link href="https://abdk.consulting/">ABDK Consulting</Link>
                    </>
                  } />
      <CardContent>
        <Typography variant="body1" paragraph color="textSecondary">
          Version: {VERSION.TAG && VERSION.TAG.substring (VERSION.TAG.lastIndexOf ('/') + 1)}
                   {VERSION.COMMIT && VERSION.COMMIT}{VERSION.BRANCH && '@' + VERSION.BRANCH}
        </Typography>
        <TextField multiline
                   variant="outlined"
                   fullWidth
                   InputProps={{
                     readOnly: true,
                     style: {fontFamily: 'Monospace'},
                     rows: 24
                   }}
                   value={
                     "Copyright (c) 2019–2020, ABDK Consulting\n\nAll rights reserved.\n\n" +
                     "Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:\n\n" + 
                     "1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.\n\n" + 
                     "2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.\n\n" + 
                     "3. All advertising materials mentioning features or use of this software must display the following acknowledgement: This product includes software developed by ABDK Consulting.\n\n" + 
                     "4. Neither the name of ABDK Consulting nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.\n\n" + 
                     "THIS SOFTWARE IS PROVIDED BY ABDK CONSULTING ''AS IS'' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. " + 
                     "IN NO EVENT SHALL ABDK CONSULTING BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE."
                   } />
        <Box m={2} />
        <Typography variant="body1">
          Created by Mikhail Vladimirov &lt;<Link href="mailto:mikhail.vladimirov@gmail.com">mikhail.vladimirov@gmail.com</Link>&gt;
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small"
                color="primary"
                component="a"
                href="https://github.com/abdk-consulting/abdk-toolkit">
          GitHub
        </Button>
      </CardActions>
    </Card>
  );
}

export default Home;
